import React from 'react';

const PermissionList = ({ permissions, rolePermissions, onToggle }) => (
  <div className="max-h-96 overflow-y-auto border rounded-lg p-4 bg-white">
    {permissions.map((perm) => (
      <div key={perm.id} className="flex items-center mb-2">
        <input
          type="checkbox"
          id={`perm-${perm.id}`}
          checked={rolePermissions.includes(perm.id)}
          onChange={() => onToggle(perm.id)}
          className="mr-2"
        />
        <label htmlFor={`perm-${perm.id}`} className="text-gray-700">
          <span className="font-medium">{perm.name}</span> <span className="text-gray-400">- {perm.description}</span>
        </label>
      </div>
    ))}
  </div>
);

export default PermissionList;
